import { render, staticRenderFns } from "./SaasConfiguration.vue?vue&type=template&id=b452d6fe&"
import script from "./SaasConfiguration.vue?vue&type=script&lang=js&"
export * from "./SaasConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports